<template>
  <div class="control-group">
    <row>
      <column>
        <button
          class="toggle-group"
          :class="classes"
          type="button"
          data-toggle="collapse"
          :data-target="'#' + safeId"
          aria-expanded="false"
          :aria-controls="safeId"
        >

          <template v-if="index >= 0 && includeIndex">
            <pencil color="Orange">
              {{indexPrefix}}{{index}}.
            </pencil>
          </template>

          <template v-if="color && icon">
            <icon :glyph="icon"></icon>
          </template>

          <span class="control-group-name">
            {{ groupName }}
          </span>
          <slot name="suffix-text"></slot>
        </button>
      </column>
      <slot name="suffix"></slot>
    </row>

    <component
      :is="contentTag"
      :id="safeId"
      class="collapse"
      v-bind:class="{show: disabled ? '' : startExpanded}"
    >
      <slot></slot>
    </component>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import {StringHelper} from "../../helpers/stringHelper";

  export default Vue.extend({
    props: {
      groupName: {
        type: String,
        default: 'Control Group',
      },
      listStyle: {
        type: Boolean,
        default: false,
      },
      color: {
        type: String,
        default: '',
      },
      flipArrow: {
        type: Boolean,
        default: false,
      },
      icon: {
        type: String,
        default: null,
      },
      index: {
        type: Number,
        default: -1,
      },
      indexPrefix: {
        type: String,
        default: '',
      },
      startExpanded: {
        type: Boolean,
        default: true,
      },
      includeIndex: {
        type: Boolean,
        default: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data: function() {
      return {
        StringHelper: StringHelper
      }
    },
    computed: {
      contentTag() {
        return this.listStyle ? 'ul' : 'div';
      },
      safeId() {
        // return 'id-' + StringHelper.toID(this.groupName) + '-' + this.index;
        return 'id-' + StringHelper.toID(this.groupName);
      },
      classes() {
        return [
          this.color,
          {
            'flip-arrow': this.flipArrow,
            'disabled': this.disabled,
            'collapsed': !this.startExpanded
          }
        ]
      }
    }
  });
</script>


